<template>
  <nav class="w-full flex items-center justify-between px-8 py-4 bg-gray-900 shadow-md fixed top-0 left-0 z-10">
    <div class="text-2xl font-semibold flex items-center gap-2">
      <div v-if="!route.meta.isRoot" class="cursor-pointer hover:opacity-80 transition-opacity inline-flex" @click="goHome">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </div>
      <span>{{ route.name }}</span>
    </div>
    <div class="flex items-center gap-4">
      <Auth />
    </div>
  </nav>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';
import Auth from './Auth.vue';
const route = useRoute();
const router = useRouter();

function goHome() {
  router.push('/dashboard');
}
</script> 